import styled from 'styled-components'

export const LabelsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.size.space['01']};
  overflow: hidden;
`

export const RemainingLabelsCount = styled.span`
  color: ${({ theme }) => theme.color.content.secondary};
`
